import { msg } from '@lingui/macro';

/**
 * Shared by `:id` and `:id/:subtab` — the same detail page under both shapes.
 *
 * `handle.header` (DL-63992) puts the item breadcrumb in the global topbar in place
 * of the list title; see `docs/routing.md` (Route `handle`). Both the component and
 * the handle come back from `lazy()` so the header stays in this route's chunk
 * instead of being statically imported into the main bundle.
 */
const loadDetailRoute = async () => {
  const [{ Details }, { ItemV2TopbarHeader }] = await Promise.all([
    import('../pages/item-v2'),
    import('../features/items-v2/components/ItemV2TopbarHeader'),
  ]);
  return {
    Component: Details,
    handle: {
      name: 'Item v2 details',
      category: 'Item',
      header: ItemV2TopbarHeader,
      topbarBackground: 'primary',
    },
  };
};

/**
 * New-model Items v2 prototype routes (DL-62519) — mock-only, on their own
 * `/item-v2` namespace so the existing `/item` routes stay frozen. Detail is
 * `:id` with an optional `:subtab` segment (default tab at bare `/item-v2/:id`).
 */
export const ItemV2Routes = {
  path: 'item-v2',
  async lazy() {
    const { Parent } = await import('../pages/item-v2');
    return { Component: Parent };
  },
  handle: { name: 'Items v2 list', category: 'Items', title: msg`Items (v2)` },
  children: [
    {
      index: true,
      async lazy() {
        const { Index } = await import('../pages/item-v2');
        return { Component: Index };
      },
    },
    {
      path: ':id',
      lazy: loadDetailRoute,
    },
    {
      path: ':id/:subtab',
      lazy: loadDetailRoute,
    },
  ],
};
